import React from'react';
import {
  isDriverPaymentConfirmed,
  isUserPaymentSubmitted,
} from'../../utils/paymentConfirmation';

const RideCompleted = ({
  booking,
  paymentStatus,
  showPaymentModal,
  setShowPaymentModal,
}) => {
  const userPaid = isUserPaymentSubmitted(booking, paymentStatus);
  const driverConfirmed = isDriverPaymentConfirmed(booking, paymentStatus);
  const awaitingDriverConfirmation = userPaid && !driverConfirmed;

  return (
    <div className="bg-white text-center hidden md:block">
      <div className="w-full h-80 md:h-96 lg:h-[500px] bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center overflow-hidden">
        <img
          src="/ridecompleted.png"
          alt="Ride Completed"
          className="w-full h-full object-contain"
        />
      </div>

      <div className="p-6 md:p-8 border-b border-gray-100">
        <div className="flex flex-col items-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
            Ride Completed
          </h2>
          <p className="text-gray-600 text-base md:text-lg mb-2 font-semibold">
            Your ride has been completed successfully
          </p>
          <div className="bg-gray-50 px-6 py-2 rounded-lg mt-2 border border-gray-100">
            <p className="text-gray-600 font-medium text-sm">
              Thank you for using our service
            </p>
          </div>

          {awaitingDriverConfirmation ? (
            <div className="mt-4 max-w-md rounded-lg border border-amber-200 bg-amber-50 px-6 py-3">
              <p className="text-amber-900 font-semibold text-base">
                Payment sent — waiting for driver confirmation
              </p>
              <p className="mt-1 text-sm text-amber-800">
                You can rate your trip after the driver confirms they received payment.
              </p>
            </div>
          ) : driverConfirmed ? (
            <div className="bg-gray-50 px-6 py-3 rounded-lg mt-4 border border-gray-100">
              <p className="text-gray-900 font-semibold text-base flex items-center justify-center space-x-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>
                  Payment {paymentStatus?.method === 'cash' ? 'confirmed' : 'completed'}
                </span>
              </p>
            </div>
          ) : !showPaymentModal ? (
            <div className="mt-4">
              <button
                onClick={() => setShowPaymentModal(true)}
                className="bg-gray-900 hover:bg-gray-800 text-white font-semibold px-8 py-3 rounded-lg shadow-sm hover:shadow-md transition-all"
              >
                Complete Payment
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default RideCompleted;
